export enum ProfileQueryKeys {
  PROFILE = 'PROFILE',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  OVERVIEW = 'OVERVIEW',
  HIGHLIGHTS = 'HIGHLIGHTS',
  NETWORKERS = 'NETWORKERS',
  INVITATIONS = 'INVITATIONS',
  CONNECTIONS = 'PROFILE_CONNECTIONS',
  MUTUAL_CONNECTIONS = 'MUTUAL_CONNECTIONS',
  MUTUAL_CONNECTIONS_COUNT = 'MUTUAL_CONNECTIONS_COUNT',
  PROJECTS = 'PROJECTS',
  PROJECT = 'PROJECT',
  VIEWS = 'VIEWS',
  HIDDEN_PROFILE = 'HIDDEN_PROFILE',
  ANALYTICS = 'ANALYTICS',
}
